import { type ReactNode } from "react"
import { createPortal } from "react-dom"

/**
 * Leva um modal feito à mão para o <body>, como o Dialog do shadcn já faz.
 *
 * `position: fixed` só cobre a tela inteira quando nenhum ancestral tem transform,
 * filter, backdrop-filter, zoom ou contain — senão o "fixo" passa a valer dentro daquele
 * ancestral, e o véu aparece cortado (foi o bug do "Enviar Convite": faixa descoberta no
 * topo). No <body> não há ancestral para prender.
 */
export function ModalPortal({ children }: { children: ReactNode }) {
  if (typeof document === "undefined") return null
  return createPortal(children, document.body)
}

export default ModalPortal
